import {
  AmProject,
  WhatIfScenarioConfig,
  WhatIfScenarioInputValues, WhatIfScenarioValuesPerProject,
  WhatIfScenarioRecord
} from "../../ps-types";
import {assocPath, clone, indexBy, prop, values} from "ramda";
import {ClosableSection} from "../../ClosableSection";
import {Button, Grid, Header, Loader, Segment} from "semantic-ui-react";
import React, {useState} from "react";
import {LocatorsMapInput} from "./LocatorsMapInput";
import {getSalesforceConfigKeys, getSalesforceValues} from "./whatIfScenarios.client";
import {useCompanyId} from "../../core";
import {useMessages} from "../../ui/MessagesProvider";
import {authStorage} from "../../auth";
import {getAmProjectConfig} from "../../ps-models";
import { LoadfromDataSourceBtn } from "./LoadFromDataSourceBtn";

export function ProjectVersionInputs({config, inputData, updateInputData, projects}: {
  config: WhatIfScenarioConfig,
  inputData: WhatIfScenarioRecord['inputData'],
  projects: AmProject[],
  updateInputData: (scenario: WhatIfScenarioRecord['inputData']) => void,
}) {


  const projectVersionInputs = inputData.projectVersionInputs || {};
  const projectVersions = inputData.projectVersions;
  const companyId = useCompanyId();
  const company = authStorage.getCompany();
  let { collection, namespace } = getAmProjectConfig(company);


  const selectedProjects = projects.filter(p => projectVersions
    .some(pv => pv.projectId === p.id));

  let projectsById = indexBy(prop("id"), selectedProjects);


  const updateProjectValues = (projectId: string, versionId: string, values: WhatIfScenarioInputValues) => {
    let key = projectId + "-" + versionId;
    let projectVersionInputsUpdated = assocPath([key], values, projectVersionInputs);
    updateInputData({...inputData, projectVersionInputs: projectVersionInputsUpdated});
  }

  return <div>
    <div style={{marginBottom: "20px", position: "relative"}}>
    <h3>Projects
      </h3>
    <LoadfromDataSourceBtn variant="project-version-inputs" projectVersions={inputData.projectVersions} config={config} onDataLoaded={(updatedProjectVersionInputs) => {        
        updateInputData({...inputData, projectVersionInputs: updatedProjectVersionInputs});
    }} />
    </div>

    <div style={{marginBottom: "20px"}}>
    {projectVersions.map(pv => {
      let p = projectsById[pv.projectId];

      if(!p) return null;

      let versionDesc = p.versions.find(v => v.versionId === pv.versionId)?.title;
      let values = projectVersionInputs[pv.projectId + "-" + pv.versionId] || {};
      return <div>
        <ClosableSection opened={false} level="title-bar" title={<strong>{p.name} Version: {versionDesc}</strong>}>
          <div style={{padding: "10px"}}>
          <Grid>
            {config && <LocatorsMapInput
                inputValues={values}
                mappingConfig={config.mappingConfig}
                onValuesUpdated={(values) => {
                  updateProjectValues(p.id, pv.versionId, values);
                }}
            />}
          </Grid>
          </div>
        </ClosableSection>
      </div>
    })
    }
    </div>
  </div>
}